var _effectorFileName = "/builds/gmini/front-ui-kit/src/SelectMultiple/hooks/useSelectHandlers.tsx";
import { useCallback } from 'react';
export const useSelectHandlers = ({
  onChange,
  value,
  autocompleteInput = true,
  onBlur,
  renderSelectValue,
  onReset,
  options,
  variables,
  onKeyDown
}) => {
  const onFocus = () => {
    variables.setAnchorEl(variables.inputRef.current);
    variables.setFocused(true);
  };

  const onBlurHandler = useCallback(() => {
    var _variables$inputRef, _variables$inputRef$c;

    variables.setAnchorEl(null);
    variables.setFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(value);
    variables.setInputValue('');
    (_variables$inputRef = variables.inputRef) === null || _variables$inputRef === void 0 ? void 0 : (_variables$inputRef$c = _variables$inputRef.current) === null || _variables$inputRef$c === void 0 ? void 0 : _variables$inputRef$c.blur();
  }, [onBlur, value, variables]);
  const renderSelectInputValue = useCallback(() => renderSelectValue === null || renderSelectValue === void 0 ? void 0 : renderSelectValue({
    options: value
  }), [renderSelectValue, value]);
  const onResetSelectInput = useCallback(() => {
    onChange === null || onChange === void 0 ? void 0 : onChange([]);
    variables.setInputValue('');
    onReset === null || onReset === void 0 ? void 0 : onReset();
  }, [onChange, onReset, variables]);
  const onMouseEnterOption = useCallback(index => variables.setFocusedOptionIdx(index), [variables]);
  const isExistItem = useCallback((item, newValue) => JSON.stringify(item) === JSON.stringify(newValue), []);
  const onChangeHandler = useCallback(newValue => {
    if (value.some(valueItem => isExistItem(valueItem, newValue))) {
      onChange === null || onChange === void 0 ? void 0 : onChange(value.filter(valueItem => !isExistItem(valueItem, newValue)));
    } else {
      onChange === null || onChange === void 0 ? void 0 : onChange([...value, newValue]);
    }
  }, [isExistItem, onChange, value]);
  const onKeyDownHandler = useCallback(event => {
    if (!options) {
      return;
    }

    switch (event.key) {
      case 'ArrowDown':
        {
          event.preventDefault();
          const prevIndex = variables.focusedOptionIdx >= options.length - 1 ? 0 : variables.focusedOptionIdx + 1;
          variables.setFocusedOptionIdx(prevIndex);
          break;
        }

      case 'ArrowUp':
        {
          event.preventDefault();
          const nextIndex = variables.focusedOptionIdx <= 0 ? options.length - 1 : variables.focusedOptionIdx - 1;
          variables.setFocusedOptionIdx(nextIndex);
          break;
        }

      case 'Tab':
      case 'Enter':
        {
          const selectedItem = (options === null || options === void 0 ? void 0 : options[variables.focusedOptionIdx]) || null;

          if (selectedItem) {
            event.preventDefault();
            onChangeHandler(selectedItem);
          }

          break;
        }

      case 'Escape':
        event.preventDefault();
        onBlurHandler();
        variables.setFocusedOptionIdx(0);
        break;
    }

    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  }, [options, onKeyDown, onBlurHandler, variables, onChangeHandler]);
  const onChangeInputValue = useCallback(event => {
    if (!autocompleteInput) {
      return;
    }

    variables.setInputValue(event.target.value);
  }, [autocompleteInput, variables]);
  const onSelect = useCallback(newValue => {
    var _variables$inputRef2, _variables$inputRef2$;

    onChangeHandler(newValue);
    (_variables$inputRef2 = variables.inputRef) === null || _variables$inputRef2 === void 0 ? void 0 : (_variables$inputRef2$ = _variables$inputRef2.current) === null || _variables$inputRef2$ === void 0 ? void 0 : _variables$inputRef2$.focus();
  }, [onChangeHandler, variables.inputRef]);
  return {
    onSelect,
    onChangeInputValue,
    onKeyDown: onKeyDownHandler,
    onMouseEnterOption,
    onResetSelectInput,
    onFocus,
    renderSelectInputValue,
    onBlurHandler
  };
};